import React from 'react'

function Footer() {
    return (
        <div style={{margin:"30px 0 40px 0"}}>
            <h4 style={{textAlign: 'center'}}>Made by
            <span style={{color:"rgb(59, 179, 59)"}}>{" "} 
            <a href="https://kennethrazalan.netlify.app/" rel="noreferrer" target="_blank">
                Kenneth Razalan </a>
            </span>
            </h4>
        </div>
    )
}

export default Footer
